module.exports = __webpack_public_path__ + "img/ExhibitNormalTitle.80e41859.png";